import { useState, useEffect } from 'react';

import { DEFAULT_VALUE, DEFAULT_VALUE_MONTH } from '../_config/constant';

const useSelector = ({
  defaultValue,
  onConfirm,
  onCancel,
  close,
  defaultType,
}: any) => {
  const [rangeDate, setRangeDate] = useState(
    defaultValue ?? DEFAULT_VALUE.value,
  );
  const [type, setType] = useState(defaultType ?? DEFAULT_VALUE.type);
  const [errorMessage, setErrorMessage] = useState(['', '']);
  const getErrorMessage = (rangeDate: any[]) => {
    const isInValid = (value: string | number) => {
      // 不能非数字、小于0、小数
      return (
        isNaN(value) ||
        Number(value) <= 0 ||
        parseInt(value) !== parseFloat(value)
      );
    };

    let errorMessageStart = (() => {
      if (isInValid(rangeDate[0])) {
        return 'Please enter correct date';
      }
      return '';
    })();
    let errorMessageEnd = (() => {
      if (isInValid(rangeDate[1])) {
        return 'Please enter correct date';
      }
      return '';
    })();

    if (errorMessageEnd && errorMessageStart) {
      errorMessageStart = '';
    }

    return [errorMessageStart, errorMessageEnd];
  };

  const handleTypeChange = (type: string) => {
    const errorMessage = getErrorMessage(rangeDate);
    setErrorMessage(errorMessage);
    setType(type);
    setRangeDate(
      type === 'days' ? DEFAULT_VALUE?.value : DEFAULT_VALUE_MONTH?.value,
    );
  };

  const handleRangeDateChange = (newRangeDate: any) => {
    const errorMessage = getErrorMessage(newRangeDate);
    setErrorMessage(errorMessage);
    setRangeDate(newRangeDate);
  };

  const handleConfirm = () => {
    if (errorMessage?.some((item) => item)) return;

    if (Number(rangeDate[0]) > Number(rangeDate[1])) {
      rangeDate.reverse();
    }

    onConfirm?.(rangeDate, type);
    close?.();
  };

  const handleCancel = () => {
    onCancel?.();
    close?.();
  };

  useEffect(() => {
    setErrorMessage(getErrorMessage(rangeDate));
  }, [rangeDate]);

  return {
    type,
    rangeDate,
    errorMessage,
    handleConfirm,
    handleCancel,
    handleTypeChange,
    handleRangeDateChange,
  };
};

export default useSelector;
